import { render, staticRenderFns } from "./superviseTaskCompany.vue?vue&type=template&id=25bc3210&scoped=true&"
import script from "./superviseTaskCompany.vue?vue&type=script&lang=js&"
export * from "./superviseTaskCompany.vue?vue&type=script&lang=js&"
import style0 from "./superviseTaskCompany.vue?vue&type=style&index=0&id=25bc3210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bc3210",
  null
  
)

export default component.exports